'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('./index.styl');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('@ali/prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get_locale = require('@ali/brokkoli/lib/utils/get_locale');

var _get_locale2 = _interopRequireDefault(_get_locale);

var _getBgImgOrColor = require('@ali/unit/utils/getBgImgOrColor');

var _getBgImgOrColor2 = _interopRequireDefault(_getBgImgOrColor);

var _getColor = require('@ali/unit/utils/getColor');

var _getColor2 = _interopRequireDefault(_getColor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Index = function (_Component) {
  _inherits(Index, _Component);

  function Index(props) {
    _classCallCheck(this, Index);

    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));

    _this.state = {};
    _this.state.hTitle = {};
    return _this;
  }

  _createClass(Index, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._renderImg();
    }
  }, {
    key: '_renderImg',
    value: function _renderImg() {
      var _this2 = this;

      var bgTitle = this.props.bgTitle;

      if (bgTitle.indexOf('#') !== 0 && bgTitle.indexOf('r') !== 0) {
        this.setState({ isBgImg: true });
        var $img = document.createElement('img');
        $img.setAttribute('src', bgTitle);
        $img.onload = function () {
          _this2.setState({ hTitle: { height: $img.height / 1000 + 'rem' } });
        };
      }
    }
  }, {
    key: '_close',
    value: function _close() {
      var close = this.props.close;

      if (close) close();
    }
  }, {
    key: '_renderTitle',
    value: function _renderTitle() {
      var _props = this.props,
          bgTitle = _props.bgTitle,
          title = _props.title,
          colorTitle = _props.colorTitle;
      var _state = this.state,
          isBgImg = _state.isBgImg,
          hTitle = _state.hTitle;

      var bg = isBgImg ? { backgroundImage: 'url(' + bgTitle + ')' } : { backgroundColor: bgTitle };
      return _react2.default.createElement(
        'div',
        { className: 'broccoli-cmp-pop-title', style: _extends({}, bg, hTitle, (0, _getColor2.default)(colorTitle)) },
        (0, _get_locale2.default)(title),
        _react2.default.createElement('div', { className: ' broccoli-cmp-pop-close broccoli-cmp-pop-close-guanbi', onClick: this._close.bind(this) })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          width = _props2.width,
          bgContent = _props2.bgContent,
          cls = _props2.cls;

      return _react2.default.createElement(
        'div',
        { className: 'broccoli-cmp-pop ' + cls },
        _react2.default.createElement(
          'div',
          { className: 'broccoli-cmp-pop-eject', style: {
              width: (width > 0 ? width : 570) / 1000 + 'rem'
            } },
          this._renderTitle(),
          _react2.default.createElement(
            'div',
            { className: 'broccoli-cmp-pop-content', style: _extends({}, (0, _getBgImgOrColor2.default)(bgContent)) },
            this.props.children
          )
        )
      );
    }
  }]);

  return Index;
}(_react.Component);

Index.propTypes = {
  /**
   * @title 标题颜色/切图
   */
  bgTitle: _propTypes2.default.string,
  /**
   * @title 弹窗title文案(巴别塔定义的key)
   */
  title: _propTypes2.default.string,
  /**
   * @title 弹窗内容背景色、背景图设置，非必填，默认白色背景
   */
  bgContent: _propTypes2.default.string,
  /**
   * @title 弹窗宽度默认570
   */
  width: _propTypes2.default.number,
  /**
   * @title 给整个弹窗加class name(非必须)
   */
  cls: _propTypes2.default.string
};
Index.defaultProps = {
  container: true,
  bgTitle: '#9c4ac6',
  // bgTitle: require('./title.png'),
  // bgTitle: 'http://img.ucweb.com/s/uae/g/55/lfk/title.jpg',
  // bgTitle: 'http://img.ucweb.com/s/uae/g/55/lfk/daycountdown.png',
  width: 500,
  cls: ''
};
exports.default = Index;